//Util
import { ICONES_ACESSO } from "@/frontend/utils/icones";

function AutorizacaoRequerida() {
  return (
    <div className="d-flex align-items-center justify-content-end text-warning">
      <div className="me-2">{ICONES_ACESSO.AUTORIZACAO_REQUERIDA} </div>
      Autorização requerida!
    </div>
  );
}

export default AutorizacaoRequerida;
